import { PaymentProcessingInfoService } from './services';
import type { Init } from './types';
import type { MergedDataReturnType, MergedHandlersReturnType } from '../../types';
import { WithApi } from '../WithApi';

export type PaymentProcessingInfoData = MergedDataReturnType<[PaymentProcessingInfoService]>;

export type PaymentProcessingInfoHandlers = MergedHandlersReturnType<[PaymentProcessingInfoService]>;

type TApi = ReturnType<PaymentProcessingInfoService['api']>;

export class PaymentProcessingInfoManager extends WithApi<TApi> {
  public paymentProcessingInfoInit = ({ pageStore, t }: Init) => {
    const paymentProcessingInfo = new PaymentProcessingInfoService(pageStore, t);

    this.initApi({
      ...paymentProcessingInfo.api(),
    });

    return {
      status: 'loaded',
      data: {
        ...paymentProcessingInfo.data(),
      },
      handlers: {
        ...paymentProcessingInfo.handlers(),
      },
    } as const;
  };
}
